/* t7-3 remate 3 (B3): vive FUERA de la pagina porque el candado del perimetro del profe
 * (`lib/perimetroProfe.tanda26.test.js`) lee como frase todo literal con letras y espacios, y esto es CSS. */
/** t7-3 remate 3 (B3): la barra de desplazamiento horizontal de la tabla, SIEMPRE a la vista en computadora,
    delgada y con los colores del panel (la hoja de Tailwind no la trae: va en su propio `<style>`, acotada a la
    caja de la tabla; los estilos en linea no pueden pintar una barra de desplazamiento). */
export const ESTILO_DE_LA_BARRA = [
  '[data-avance-desliza="ancho"]::-webkit-scrollbar { height: 10px; }',
  '[data-avance-desliza="ancho"]::-webkit-scrollbar-track { background: #1c1c1c; }',
  '[data-avance-desliza="ancho"]::-webkit-scrollbar-thumb { background: #5a5a5a; border-radius: 999px; border: 2px solid #1c1c1c; }',
  '@supports not selector(::-webkit-scrollbar) { [data-avance-desliza="ancho"] { scrollbar-width: thin; scrollbar-color: #5a5a5a #1c1c1c; } }',
].join('\n');
